import React from 'react';
import { useParameterizedQuery } from 'react-fetching-library';
import {
  Portal,
  Modal,
  Card,
  CardContent,
  Button,
  Typography,
  Stack,
  Box
} from '@mui/material';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';

import { useApplication } from '../../../ApplicationsContext';
import { updateOrder } from '../../../../../../services/redux-actions';
import { unsignAgreementAction } from '../../../../../../services/request';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function ConfirmUnsignAgreementModal({
  handleClose,
  order,
  application,
  type = 'agreement'
}) {
  const { query } = useParameterizedQuery(unsignAgreementAction);
  const dispatch = useDispatch();

  const handleClick = async () => {
    if (order) {
      const { error, loading } = await query(order.id, { model: 'Order' });
      if (!error && !loading) {
        dispatch(updateOrder({ ...order, agreement_is_signed: false, agreement_signing_date: null, return_agreement: false }));
        handleClose();
        toast.success('Podpis został usunięty');
      }
    } else {
      const { rowData, setRowData } = useApplication();
      const { error, loading } = await query(application.id, { model: 'EmployeeApplication' });
      if (!error && !loading) {
        const checkboxes = rowData.checkbox_sections;
        const umowa_idx = rowData.checkbox_sections.findIndex(section => section.name == 'UMOWA');
        const zwrocona_idx = checkboxes[umowa_idx].items.findIndex(item => item.type == 2);
        checkboxes[umowa_idx].items[zwrocona_idx].value = false;
        const kwestionariusz_idx = rowData.checkbox_sections.findIndex(section => section.name == 'KWESTIONARIUSZ');
        if (kwestionariusz_idx) {
          const zwrocony_idx = checkboxes[kwestionariusz_idx].items.findIndex(item => item.type == 2);
          checkboxes[kwestionariusz_idx].items[zwrocony_idx].value = false;
        }
        const oswiadczenie_studenta_idx = rowData.checkbox_sections.findIndex(section => section.name == 'OŚWIADCZENIE STUDENTA');
        if (oswiadczenie_studenta_idx) {
          const zwrocone_idx = checkboxes[oswiadczenie_studenta_idx].items.findIndex(item => item.type == 2);
          checkboxes[oswiadczenie_studenta_idx].items[zwrocone_idx].value = false;
        }
        setRowData({ ...rowData, checkbox_sections: checkboxes, agreement_is_signed: false, agreement_signing_date: null, is_agreement_sent_to_dgcs: false });
        handleClose();
        toast.success('Podpis został usunięty');
      }
      if (error) {
        toast.error('Nie udało się usunąć podpisu');
      }
    }
  };

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card sx={{ ...style, width: 450 }}>
          <CardContent>
            <Typography align="center">
              {
                'Czy na pewno chcesz usunąć podpis z umowy? Podpisanie zostanie cofnięte, a dokumenty oznaczone jako niezwrócone.'
              }
            </Typography>
            <Box height={40} />
            <Stack direction="row" justifyContent="space-between">
              <Button
                variant="outlined"
                sx={{ flex: 0.45 }}
                onClick={handleClose}
              >
                Anuluj
              </Button>
              <Button
                variant="contained"
                sx={{ flex: 0.45 }}
                onClick={handleClick}
              >
                Usuń podpis
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
}
